import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20%);
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: ${({ topOffset }) => (topOffset ? `${topOffset}px 16px 16px` : '16px')};
  z-index: 10000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  padding: 32px 24px;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '700px'};
  height: fit-content;
  max-height: 100%;
  overflow-y: auto;
  z-index: 10001;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: ${({ isClosing }) => (isClosing ? fadeOut : fadeIn)} 0.4s ease-out;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;
